/**
 * Offer step intro timers/animation — PB-FND-34 (migrated from pb-logic-offer-intro.liquid).
 */
(function (global) {
  'use strict';

  function patchProductBuilder() {
    var pb = global.productBuilder;
    if (!pb) return;

    /* MODULE: OFFER STEP INTRO — timers re-query #offers-list-js each tick so re-renders never leave stale node refs */
      (function() {
        /* Guide fades in after msgDelay; bundles start after msgDelay + messageDwell (larger dwell = later cards). */
        var PB_OFFER_INTRO_MSG_MS = 80;
        var PB_OFFER_INTRO_MESSAGE_DWELL_MS = 620;
        var PB_OFFER_INTRO_BUNDLE_STAGGER_MS = 400;
        var PB_OFFER_INTRO_TRANSITION_BUFFER_MS = 700;
        /* After moveStep, defer WAAPI commit so motion stays on-screen; lower = earlier start. */
        var PB_OFFER_INTRO_VIEWPORT_DELAY_MS = 220;
    
        function stripOfferIntroHiddenFromDom(root) {
          if (!root) return;
          root.querySelectorAll('.pb-bundle-tier-intro-body.pb-offer-intro-hidden').forEach(function(el) {
            el.classList.remove('pb-offer-intro-hidden');
            el.removeAttribute('aria-hidden');
          });
          root.querySelectorAll('.pb-bundle-save-ribbon.pb-offer-intro-hidden').forEach(function(el) {
            el.classList.remove('pb-offer-intro-hidden');
            el.removeAttribute('aria-hidden');
          });
          root.querySelectorAll('.pb-offer-bundle-tier').forEach(function(el) {
            el.classList.remove('pb-offer-intro-hidden');
            el.removeAttribute('aria-hidden');
            el.style.opacity = '';
            el.style.transform = '';
            el.style.pointerEvents = '';
            el.style.willChange = '';
          });
          root.querySelectorAll('.pb-bundle-tier-intro-body').forEach(function(el) {
            el.style.opacity = '';
            el.style.transform = '';
            el.style.pointerEvents = '';
            el.style.willChange = '';
          });
          root.querySelectorAll('.pb-bundle-save-ribbon').forEach(function(el) {
            el.style.opacity = '';
            el.style.transform = '';
            el.style.pointerEvents = '';
            el.style.willChange = '';
          });
          var g = root.querySelector('#pb-offer-guide-msg');
          if (g) {
            g.classList.remove('pb-offer-intro-hidden');
            g.removeAttribute('aria-hidden');
            g.style.opacity = '';
            g.style.transform = '';
            g.style.pointerEvents = '';
            g.style.willChange = '';
          }
          root.classList.remove('pb-offer-intro-pending');
          root.classList.remove('pb-offer-intro-pending-hide');
        }
    
        function getBundleTierIntroTargets(tierEl) {
          if (!tierEl) return { body: null, ribbon: null };
          return {
            body: tierEl.querySelector('.pb-bundle-tier-intro-body'),
            ribbon: tierEl.querySelector('.pb-bundle-save-ribbon')
          };
        }
    
        function pbOfferIntroHideTierTargets(tierEl) {
          var targets = getBundleTierIntroTargets(tierEl);
          if (targets.body) {
            targets.body.style.opacity = '0';
            targets.body.style.transform = 'translate3d(0, 18px, 0)';
            targets.body.style.willChange = 'opacity, transform';
          }
          if (targets.ribbon) {
            targets.ribbon.style.opacity = '0';
            targets.ribbon.style.transform = 'translate3d(0, 18px, 0)';
            targets.ribbon.style.willChange = 'opacity, transform';
          }
        }
    
        function pbOfferIntroLiftTierTargets(tierEl) {
          var targets = getBundleTierIntroTargets(tierEl);
          if (targets.body) {
            targets.body.style.opacity = '';
            targets.body.style.transform = '';
            targets.body.style.willChange = '';
          }
          if (targets.ribbon) {
            targets.ribbon.style.opacity = '';
            targets.ribbon.style.transform = '';
            targets.ribbon.style.willChange = '';
          }
        }
    
        function pbLiftOfferIntroPrehideIfStuck(root) {
          if (!root) return;
          root.classList.remove('pb-offer-intro-pending-hide');
          var g = root.querySelector('#pb-offer-guide-msg');
          if (g) {
            g.style.opacity = '';
            g.style.transform = '';
            g.style.willChange = '';
          }
          root.querySelectorAll('.pb-offer-bundle-tier').forEach(function(el) {
            pbOfferIntroLiftTierTargets(el);
          });
        }
    
        Object.assign(pb, {
          /** First paint on offer step must not reuse init hash (skips innerHTML + confuses intro). */
          invalidateOffersListContentHash: function() {
            var el = document.getElementById('offers-list-js');
            if (el && el.dataset) delete el.dataset.pbOffersContentHash;
          },
    
          _offerIntroWaapi: null,
    
          _cancelOfferIntroWaapi: function() {
            var list = this._offerIntroWaapi;
            if (list && list.length) {
              list.forEach(function(a) {
                try {
                  a.cancel();
                } catch (e) {}
              });
            }
            this._offerIntroWaapi = null;
          },
          /** Active main-flow image step index. Prefer viewport-scoped match (same as renumberSteps); fall back if layout differs. */
          getMainViewportStepNumber: function() {
            var activeImg =
              document.querySelector(
                '#main-flow-container .pb-modal-body .pb-step-viewport .pb-step.active'
              ) || document.querySelector('#main-flow-container .pb-modal-body .pb-step.active');
            if (!activeImg || !activeImg.id) return NaN;
            var m = activeImg.id.match(/img-page-(\d+)$/);
            return m ? parseInt(m[1], 10) : NaN;
          },
    
          /** Step index of the offer image step after renumberSteps (hidden #offer-step-index can lag Liquid by ±N). */
          getOfferStepNumberFromDom: function() {
            var list = document.getElementById('offers-list-js');
            if (!list) return NaN;
            var stepEl =
              list.closest('.pb-modal-body .pb-step-viewport .pb-step') || list.closest('.pb-step');
            if (!stepEl || !stepEl.id) return NaN;
            var m = stepEl.id.match(/img-page-(\d+)$/);
            return m ? parseInt(m[1], 10) : NaN;
          },
    
          /** Hide guide + bundle tiers on same tick as markup (before paint) so intro never flashes full opacity first. */
          armOfferIntroPrehide: function(container, introMode) {
            if (introMode === 'skip') return;
            if (window.BUILDER_DATA && window.BUILDER_DATA.navigationKernel) return;
            var s = window.builderState;
            if (!s || s.mode !== 'MAIN' || !s.main || s.main.offerIntroPlayed) return;
            var bundles = window.BUILDER_DATA && window.BUILDER_DATA.bundles;
            if (!bundles || !bundles.length || !container) return;
            var pb = this;
            var offerStep = typeof pb.getOfferStepNumberFromDom === 'function' ? pb.getOfferStepNumberFromDom() : NaN;
            if (isNaN(offerStep)) {
              var inp = document.getElementById('offer-step-index');
              offerStep = inp ? parseInt(inp.value, 10) : NaN;
            }
            if (isNaN(offerStep)) return;
            var ctx = typeof pb.getActiveContext === 'function' ? pb.getActiveContext() : null;
            var ctxStep = ctx && ctx.step != null ? parseInt(ctx.step, 10) : NaN;
            var view = typeof pb.getMainViewportStepNumber === 'function' ? pb.getMainViewportStepNumber() : NaN;
            var aligned = (!isNaN(view) && view === offerStep) || (!isNaN(ctxStep) && ctxStep === offerStep);
            var img = document.getElementById('img-page-' + offerStep);
            if (!aligned || !img || !img.classList.contains('active')) return;
    
            container.classList.add('pb-offer-intro-pending');
            container.classList.add('pb-offer-intro-pending-hide');
            var guide = container.querySelector('#pb-offer-guide-msg');
            var tiers = container.querySelectorAll('.pb-offer-bundle-tier');
            if (guide) {
              guide.style.opacity = '0';
              guide.style.transform = 'translate3d(0, 18px, 0)';
              guide.style.willChange = 'opacity, transform';
            }
            for (var ti = 0; ti < tiers.length; ti++) {
              pbOfferIntroHideTierTargets(tiers[ti]);
            }
          },
    
          _offerIntroTimerIds: null,
    
          /** Cancel stagger timers only — no DOM strip. Used at start of renderOffers: innerHTML
              replaces the list next, so stripping pending/hidden here killed in-flight animations
              (second renderOffers after intro committed left static UI with no motion). */
          _offerIntroDeferredCommitId: null,
    
          cancelOfferIntroTimersOnly: function() {
            if (this._offerIntroDeferredCommitId) {
              clearTimeout(this._offerIntroDeferredCommitId);
              this._offerIntroDeferredCommitId = null;
            }
            this._cancelOfferIntroWaapi();
            var ids = this._offerIntroTimerIds;
            if (ids && ids.length) {
              ids.forEach(function(id) { clearTimeout(id); });
            }
            this._offerIntroTimerIds = [];
          },
    
          clearOfferIntroTimers: function() {
            /* Cancel pending intro timeouts; strip hidden state only when we actually cancelled
               timers OR the list still has pb-offer-intro-pending (stuck mid-intro). Stripping on
               every call broke maybeRun's first line after renderOffers (empty ids): fresh DOM was
               stripped before intro ran, so Original Song lost the animation while Monogram still
               looked fine due to timing. */
            if (this._offerIntroDeferredCommitId) {
              clearTimeout(this._offerIntroDeferredCommitId);
              this._offerIntroDeferredCommitId = null;
            }
            this._cancelOfferIntroWaapi();
            var ids = this._offerIntroTimerIds;
            var hadTimers = ids && ids.length;
            if (hadTimers) {
              ids.forEach(function(id) { clearTimeout(id); });
            }
            this._offerIntroTimerIds = [];
            var root = document.getElementById('offers-list-js');
            if (root && (hadTimers || root.classList.contains('pb-offer-intro-pending'))) {
              stripOfferIntroHiddenFromDom(root);
            }
          },
    
          _queueOfferIntroTimer: function(fn, delay) {
            if (!this._offerIntroTimerIds) this._offerIntroTimerIds = [];
            var id = setTimeout(fn, delay);
            this._offerIntroTimerIds.push(id);
            return id;
          },
    
          /* introMode: 'auto' | 'skip' (no stagger / timers). */
          maybeRunOfferIntroAfterRender: function(container, introMode) {
            var pb = this;
            if (introMode === 'skip') return;
            if (window.BUILDER_DATA && window.BUILDER_DATA.navigationKernel) {
              var rootNav = container || document.getElementById('offers-list-js');
              stripOfferIntroHiddenFromDom(rootNav);
              if (window.builderState && window.builderState.main) {
                window.builderState.main.offerIntroPlayed = true;
              }
              return;
            }
    
            var bundles = window.BUILDER_DATA && window.BUILDER_DATA.bundles;
            if (!container || !bundles || !bundles.length) return;
    
            var s = window.builderState;
            if (!s || s.mode !== 'MAIN') return;
    
            /* Once per visit to the offer step — do not replay on selectBundle / renderOffers refreshes. */
            if (s.main && s.main.offerIntroPlayed) return;
    
            var offerInput = document.getElementById('offer-step-index');
            if (!offerInput) return;
    
            function tryScheduleIntro() {
              if (s.main && s.main.offerIntroPlayed) return;
              var ctx = window.productBuilder && typeof window.productBuilder.getActiveContext === 'function'
                ? window.productBuilder.getActiveContext()
                : null;
              var ctxStep = ctx && ctx.step != null ? parseInt(ctx.step, 10) : NaN;
              var viewportStep = typeof window.productBuilder.getMainViewportStepNumber === 'function'
                ? window.productBuilder.getMainViewportStepNumber()
                : NaN;
              var offerFromDom =
                typeof pb.getOfferStepNumberFromDom === 'function' ? pb.getOfferStepNumberFromDom() : NaN;
              var offerStep = !isNaN(offerFromDom) ? offerFromDom : parseInt(offerInput.value, 10);
              var listRoot = document.getElementById('offers-list-js');
              /* Same node moveStep activates — closest() from #offers-list-js can resolve a different .pb-step in edge DOMs. */
              var offerImgPageEl = !isNaN(offerStep) ? document.getElementById('img-page-' + offerStep) : null;
              var imgOfferActive = !!(offerImgPageEl && offerImgPageEl.classList.contains('active'));
              if (!imgOfferActive && listRoot) {
                var stepOfferEl = listRoot.closest('.pb-modal-body .pb-step-viewport .pb-step') || listRoot.closest('.pb-step');
                imgOfferActive = !!(stepOfferEl && stepOfferEl.classList.contains('active'));
              }
              var viewportAligned =
                !isNaN(viewportStep) && viewportStep === offerStep;
              var ctxAligned = !isNaN(ctxStep) && ctxStep === offerStep;
              /* Either viewport or ctx matches offer index (viewport query can lag or pick wrong node during transition). */
              var onOfferStepNow =
                !isNaN(offerStep) &&
                imgOfferActive &&
                (viewportAligned || ctxAligned);
              if (isNaN(offerStep) || !onOfferStepNow) {
                return;
              }
    
              var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
              if (mq && mq.matches) {
                if (s.main) s.main.offerIntroPlayed = true;
                return;
              }
    
              var upsell = container.querySelector('.pb-offer-upsell-block');
              var guide = container.querySelector('#pb-offer-guide-msg');
              var bundleCards = upsell ? upsell.querySelectorAll('.pb-offer-bundle-tier') : [];
              if (!upsell || !guide || !bundleCards.length) {
                pbLiftOfferIntroPrehideIfStuck(container);
                return;
              }
    
              var tierCount = bundles.length;
              if (bundleCards.length !== tierCount) {
                tierCount = bundleCards.length;
              }
    
              /* Defer commit until step slide finishes and user sees #img-page-N; avoids WAAPI running off-screen. */
              if (pb._offerIntroDeferredCommitId) {
                clearTimeout(pb._offerIntroDeferredCommitId);
                pb._offerIntroDeferredCommitId = null;
              }
              pb._offerIntroDeferredCommitId = setTimeout(function offerIntroDeferredCommit() {
                pb._offerIntroDeferredCommitId = null;
                if (s.main && s.main.offerIntroPlayed) return;
    
                var listR = document.getElementById('offers-list-js');
                var os2 =
                  typeof pb.getOfferStepNumberFromDom === 'function' ? pb.getOfferStepNumberFromDom() : NaN;
                if (isNaN(os2)) {
                  var oi2 = document.getElementById('offer-step-index');
                  os2 = oi2 ? parseInt(oi2.value, 10) : NaN;
                }
                var offerImgPage = !isNaN(os2) ? document.getElementById('img-page-' + os2) : null;
                var stepActive = !!(offerImgPage && offerImgPage.classList.contains('active'));
                if (!stepActive && listR) {
                  var stepOffer = listR.closest('.pb-modal-body .pb-step-viewport .pb-step') || listR.closest('.pb-step');
                  stepActive = !!(stepOffer && stepOffer.classList.contains('active'));
                }
                var ctxN = window.productBuilder && typeof window.productBuilder.getActiveContext === 'function'
                  ? window.productBuilder.getActiveContext()
                  : null;
                var ctxStepN = ctxN && ctxN.step != null ? parseInt(ctxN.step, 10) : NaN;
                var viewN = typeof window.productBuilder.getMainViewportStepNumber === 'function'
                  ? window.productBuilder.getMainViewportStepNumber()
                  : NaN;
                var viewNAligned = !isNaN(viewN) && viewN === os2;
                var ctxNAligned = !isNaN(ctxStepN) && ctxStepN === os2;
                if (isNaN(os2) || !stepActive || !(viewNAligned || ctxNAligned)) {
                  pbLiftOfferIntroPrehideIfStuck(listR);
                  return;
                }
    
                var cn = document.getElementById('offers-list-js');
                if (!cn) {
                  pbLiftOfferIntroPrehideIfStuck(listR);
                  return;
                }
                var up2 = cn.querySelector('.pb-offer-upsell-block');
                var gd = cn.querySelector('#pb-offer-guide-msg');
                var bcs = up2 ? up2.querySelectorAll('.pb-offer-bundle-tier') : [];
                if (!up2 || !gd || !bcs.length) {
                  pbLiftOfferIntroPrehideIfStuck(cn);
                  return;
                }
    
                var mq2 = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
                if (mq2 && mq2.matches) {
                  if (s.main) s.main.offerIntroPlayed = true;
                  stripOfferIntroHiddenFromDom(cn);
                  return;
                }
    
                var tc = bundles.length;
                if (bcs.length !== tc) tc = bcs.length;
    
                if (s.main) s.main.offerIntroPlayed = true;
    
                cn.classList.add('pb-offer-intro-pending');
                cn.classList.remove('pb-offer-intro-pending-hide');
                guide = gd;
                container = cn;
                bundleCards = bcs;
                tierCount = tc;
    
              var msgDelay = PB_OFFER_INTRO_MSG_MS;
              var messageDwell = PB_OFFER_INTRO_MESSAGE_DWELL_MS;
              var stagger = PB_OFFER_INTRO_BUNDLE_STAGGER_MS;
              var firstBundleAt = msgDelay + messageDwell;
              var waapiDur = 460;
              var waapiEase = 'cubic-bezier(0.16, 1, 0.3, 1)';
              var kfFrom = { opacity: 0, transform: 'translate3d(0, 18px, 0)' };
              var kfTo = { opacity: 1, transform: 'translate3d(0, 0, 0)' };
              var useWaapi = typeof guide.animate === 'function';
    
              if (useWaapi) {
                pb._cancelOfferIntroWaapi();
                guide.setAttribute('aria-hidden', 'true');
                guide.style.willChange = 'opacity, transform';
                guide.style.opacity = '0';
                guide.style.transform = 'translate3d(0, 18px, 0)';
                guide.style.pointerEvents = 'none';
                for (var hi = 0; hi < bundleCards.length; hi++) {
                  var tierTargets = getBundleTierIntroTargets(bundleCards[hi]);
                  if (tierTargets.body) {
                    tierTargets.body.setAttribute('aria-hidden', 'true');
                    tierTargets.body.style.willChange = 'opacity, transform';
                    tierTargets.body.style.opacity = '0';
                    tierTargets.body.style.transform = 'translate3d(0, 18px, 0)';
                    tierTargets.body.style.pointerEvents = 'none';
                  }
                  if (tierTargets.ribbon) {
                    tierTargets.ribbon.setAttribute('aria-hidden', 'true');
                    tierTargets.ribbon.style.willChange = 'opacity, transform';
                    tierTargets.ribbon.style.opacity = '0';
                    tierTargets.ribbon.style.transform = 'translate3d(0, 18px, 0)';
                    tierTargets.ribbon.style.pointerEvents = 'none';
                  }
                }
                if (typeof container.getBoundingClientRect === 'function') container.getBoundingClientRect();
                requestAnimationFrame(function() {
                  requestAnimationFrame(function() {
                    var anims = [];
                    anims.push(
                      guide.animate([kfFrom, kfTo], {
                        delay: msgDelay,
                        duration: waapiDur,
                        fill: 'forwards',
                        easing: waapiEase
                      })
                    );
                    for (var wj = 0; wj < tierCount; wj++) {
                      (function(cardEl, idx) {
                        if (!cardEl) return;
                        var del = firstBundleAt + stagger * idx;
                        var targets = getBundleTierIntroTargets(cardEl);
                        if (targets.body) {
                          anims.push(
                            targets.body.animate([kfFrom, kfTo], {
                              delay: del,
                              duration: waapiDur,
                              fill: 'forwards',
                              easing: waapiEase
                            })
                          );
                        }
                        if (targets.ribbon) {
                          anims.push(
                            targets.ribbon.animate([kfFrom, kfTo], {
                              delay: del,
                              duration: waapiDur,
                              fill: 'forwards',
                              easing: waapiEase
                            })
                          );
                        }
                      })(bundleCards[wj], wj);
                    }
                    pb._offerIntroWaapi = anims;
                    var lastRevealAt = tierCount ? firstBundleAt + stagger * (tierCount - 1) : msgDelay;
                    pb._queueOfferIntroTimer(function() {
                      var root = document.getElementById('offers-list-js');
                      if (root) {
                        var gu = root.querySelector('#pb-offer-guide-msg');
                        if (gu) {
                          gu.removeAttribute('aria-hidden');
                        }
                        root.querySelectorAll('.pb-offer-bundle-tier').forEach(function(c) {
                          var targets = getBundleTierIntroTargets(c);
                          if (targets.body) targets.body.removeAttribute('aria-hidden');
                          if (targets.ribbon) targets.ribbon.removeAttribute('aria-hidden');
                        });
                      }
                      stripOfferIntroHiddenFromDom(root);
                      pb._cancelOfferIntroWaapi();
                      pb.clearOfferIntroTimers();
                    }, lastRevealAt + waapiDur + PB_OFFER_INTRO_TRANSITION_BUFFER_MS);
                  });
                });
              } else {
                guide.classList.add('pb-offer-intro-hidden');
                guide.setAttribute('aria-hidden', 'true');
                for (var i = 0; i < bundleCards.length; i++) {
                  var cssTargets = getBundleTierIntroTargets(bundleCards[i]);
                  if (cssTargets.body) {
                    cssTargets.body.classList.add('pb-offer-intro-hidden');
                    cssTargets.body.setAttribute('aria-hidden', 'true');
                  }
                  if (cssTargets.ribbon) {
                    cssTargets.ribbon.classList.add('pb-offer-intro-hidden');
                    cssTargets.ribbon.setAttribute('aria-hidden', 'true');
                  }
                }
                if (typeof container.getBoundingClientRect === 'function') container.getBoundingClientRect();
                requestAnimationFrame(function() {
                  requestAnimationFrame(function() {
                    pb._queueOfferIntroTimer(function() {
                      var root = document.getElementById('offers-list-js');
                      if (!root || !root.classList.contains('pb-offer-intro-pending')) return;
                      var g = root.querySelector('#pb-offer-guide-msg');
                      if (g) {
                        g.classList.remove('pb-offer-intro-hidden');
                        g.removeAttribute('aria-hidden');
                      }
                    }, msgDelay);
    
                    for (var j = 0; j < tierCount; j++) {
                      (function(index) {
                        pb._queueOfferIntroTimer(function() {
                          var root = document.getElementById('offers-list-js');
                          if (!root || !root.classList.contains('pb-offer-intro-pending')) return;
                          var cards = root.querySelectorAll('.pb-offer-bundle-tier');
                          var card = cards[index];
                          if (card) {
                            var revealTargets = getBundleTierIntroTargets(card);
                            if (revealTargets.body) {
                              revealTargets.body.classList.remove('pb-offer-intro-hidden');
                              revealTargets.body.removeAttribute('aria-hidden');
                            }
                            if (revealTargets.ribbon) {
                              revealTargets.ribbon.classList.remove('pb-offer-intro-hidden');
                              revealTargets.ribbon.removeAttribute('aria-hidden');
                            }
                          }
                        }, firstBundleAt + stagger * index);
                      })(j);
                    }
    
                    var lastCssAt = tierCount ? firstBundleAt + stagger * (tierCount - 1) : msgDelay;
                    pb._queueOfferIntroTimer(function() {
                      var root = document.getElementById('offers-list-js');
                      stripOfferIntroHiddenFromDom(root);
                      pb.clearOfferIntroTimers();
                    }, lastCssAt + PB_OFFER_INTRO_TRANSITION_BUFFER_MS);
                  });
                });
              }
            }, PB_OFFER_INTRO_VIEWPORT_DELAY_MS);
            }
    
            /* rAF + delayed retries: viewport / active class can lag right after step transition. */
            requestAnimationFrame(function() {
              requestAnimationFrame(function() {
                tryScheduleIntro();
                setTimeout(function() {
                  if (!s.main || !s.main.offerIntroPlayed) tryScheduleIntro();
                }, 32);
                setTimeout(function() {
                  if (!s.main || !s.main.offerIntroPlayed) tryScheduleIntro();
                }, 120);
                setTimeout(function() {
                  if (!s.main || !s.main.offerIntroPlayed) tryScheduleIntro();
                }, 320);
                setTimeout(function() {
                  if (!s.main || !s.main.offerIntroPlayed) tryScheduleIntro();
                }, 700);
              });
            });
          }
        });
    
      })();
  }

  patchProductBuilder();
})(typeof window !== 'undefined' ? window : globalThis);
